// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/aviation-document-booklet.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/aviation-document-booklet/aviation-document-booklet.js';

mount([g0]);
